"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styles_1 = require("./styles");

var FullTableRowCheckbox_1 = require("./FullTableRowCheckbox");

var FullTableCell_1 = require("./FullTableCell");

var FullTableRow =
/** @class */
function (_super) {
  __extends(FullTableRow, _super);

  function FullTableRow() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FullTableRow.prototype.hasRowClick = function (index) {
    var row = this.props.row;
    return !!row.onRowClick && index + 1 === row.display.length;
  };

  FullTableRow.prototype.getActionDropdownItems = function (index) {
    var _a = this.props.row,
        actionDropdownItems = _a.actionDropdownItems,
        display = _a.display;

    if (!!actionDropdownItems && index + 1 === display.length) {
      return actionDropdownItems;
    }

    return;
  };

  FullTableRow.prototype.handleRowClick = function (event) {
    var row = this.props.row;
    return row.onRowClick ? row.onRowClick() : null;
  };

  FullTableRow.prototype.getRowClickHoverStyle = function () {
    var _a = this.props,
        hasSelectRows = _a.hasSelectRows,
        row = _a.row;

    if (row.onRowClick) {
      return hasSelectRows ? styles_1.hasSelectRowClickableStyle : styles_1.noSelectRowClickableStyle;
    }

    return null;
  };

  FullTableRow.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        row = _a.row,
        index = _a.index,
        isRowSelected = _a.isRowSelected,
        hasSelectRows = _a.hasSelectRows,
        selectRow = _a.selectRow;
    return React.createElement("div", {
      className: "row " + (isRowSelected(row) ? styles_1.selectRowStyle : styles_1.rowStyle) + " " + (row.onRowClick ? styles_1.clickableStyle : '') + " " + this.getRowClickHoverStyle(),
      role: "row",
      tabIndex: 1,
      onClick: function onClick(event) {
        return _this.handleRowClick(event);
      }
    }, hasSelectRows ? React.createElement(FullTableRowCheckbox_1.FullTableRowCheckbox, {
      key: 0,
      selected: isRowSelected(row),
      index: index,
      selectRow: selectRow
    }) : null, row.display.map(function (cell, cellIndex) {
      return React.createElement(FullTableCell_1.FullTableCell, {
        display: cell,
        key: hasSelectRows ? cellIndex + 1 : cellIndex,
        hasRowClick: _this.hasRowClick(cellIndex),
        actionDropdownItems: _this.getActionDropdownItems(cellIndex)
      });
    }));
  };

  return FullTableRow;
}(React.Component);

exports.FullTableRow = FullTableRow;